<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>Add Employee</h3>
        <p class="text-aerostar-orange">{{message}}</p>
        <app-employee-component (messageEvent)="receiveMessage($event)"/>
        <app-iam-roles-component (messageEvent)="receiveMessage($event)"/>
        <section style="padding-top: 1vw; padding-bottom: 1vw;">
            <button style="margin-right: 1vw;" mat-flat-button (click)="save()">Save</button>
            <button mat-flat-button (click)="cancel()">Cancel</button>
        </section>
    </section>
</section>